<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <div class="box">
      <blue-title class="style">主体类型</blue-title>
      <div>
        <div class="info" style="height: 70px">
          <span class="marRight">营业执照照片</span
          ><span
            ><el-image
              :src="subjectData.licenseCopy"
              alt=""
              style="width: 58px; height: 58px"
            ></el-image
          ></span>
        </div>
        <div class="info"><span class="marRight">注册号</span><span>{{subjectData.licenseNumber}}</span></div>
        <div class="info"><span class="marRight">商户名称</span><span>{{subjectData.businessLicenseInfoMerchantName}}</span></div>
        <div class="info"><span class="marRight">法人姓名</span><span>{{subjectData.businessLicenseInfoLegalPerson}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  watch: {},

  methods: {},
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  height: 100%;

  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 11px 0 18px 0;
  }
  .marRight {
    width: 90px;
    margin-right: 38px;
  }
}
</style>
